import { Manrope } from 'next/font/google'
import { FC } from 'react'

const manrope = Manrope({
  subsets: ['latin']
})

const Fonts: FC = () => (
  <style jsx global>
    {`
      :root {
        --font-manrope: ${manrope.style.fontFamily};
      }
    `}
  </style>
)

export default Fonts
